if (!customElements.get('slider-collection-list')) {
  class SliderCollectionList extends HTMLElement {
    constructor() {
      super();

      this.slidesPerGroup = parseInt(this.dataset.slidesPerGroup) || 3;

      this.selectors = {
        slider: '[data-slider]',
      };

      this.settings = {
        elements: {
          slider: this.querySelector(this.selectors.slider),
        },
        instances: {
          slider: null,
        },
        options: {
          slider: {
            loop: true,
            slidesPerView: 1,
            slidesPerGroup: 1,
            loopAdditionalSlides: 1,
            spaceBetween: 32,
            navigation: {
              prevEl: this.querySelector('.swiper-arrow--prev'),
              nextEl: this.querySelector('.swiper-arrow--next'),
            },
            breakpoints: {
              750: {
                slidesPerView: 2,
                slidesPerGroup: 2,
                loopAdditionalSlides: 2,
              },
              990: {
                slidesPerView: 3,
                slidesPerGroup: 3,
                loopAdditionalSlides: 3,
              }
            }
          },
        },
      };
    }

    connectedCallback() {
      this.init();
    }

    init() {
      this.settings.instances.slider = new Swiper(
        this.settings.elements.slider,
        this.settings.options.slider,
      );
    }
  }

  customElements.define('slider-collection-list', SliderCollectionList);
}
